import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';

import styled from '@emotion/styled';
import { CncReport } from '@gameonly/core';
import { useState } from 'react';
import Button from '../ui/Button';
import { ReactComponent as Edit } from '../ui/icons/crayon.svg';
import ViewReportModal from './ViewReportModal';

interface Props {
  report: CncReport;
  onEdit: () => void;
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  .title {
    margin-bottom: 18px;
  }
`;

const ReportInformation = ({ report, onEdit }: Props) => {
  const [isViewOpen, setViewOpen] = useState(false);
  const isValidated = !!report.validatedAt;
  const { t } = useTranslation(['cnc-reports', 'common']);

  return (
    <Container>
      {isValidated ? (
        <></>
      ) : report.isInformationComplete ? (
        <Alert
          severity="success"
          sx={{ mb: 2, backgroundColor: '#EDD2E4', color: 'black' }}
        >
          {t('cnc-reports:dashboard.information.complete')}
        </Alert>
      ) : (
        <Alert
          severity="warning"
          sx={{ mb: 2, backgroundColor: '#EDD2E4', color: 'black' }}
        >
          {t('cnc-reports:dashboard.information.incomplete')}
        </Alert>
      )}
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        {!isValidated && (
          <Button
            onClick={onEdit}
            sx={{ width: '100px' }}
            endIcon={<Edit style={{ width: '16px', height: '16px' }} />}
          >
            {t('cnc-reports:dashboard.edit-report')}
          </Button>
        )}
        {isValidated && (
          <Button onClick={() => setViewOpen(true)} sx={{ width: '150px' }}>
            {t('cnc-reports:view-modal.button')}
          </Button>
        )}
      </div>
      <ViewReportModal
        open={isViewOpen}
        report={report}
        onClose={() => setViewOpen(false)}
      />
    </Container>
  );
};

export default ReportInformation;
